import { Button, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import DisplayEmptyListAction from "../../../../../../components/DisplayEmptyListAction";
import { IDataDetalharTitulosReceber } from "../../../../../../types/api/financeiro/datalhar-titulos-receber";
import { useMemo, useState } from "react";
import DialogRegistrarRecebimento from "../../DialogRegistrarRecebimento";
import { IDataListaTitulosReceber } from "../../../../../../types/api/financeiro/pesquisar-titulos-receber";
import moment from "moment";
import { formatarValorMonetario } from "../../../../../../helpers/masks";
import AddIcon from '@mui/icons-material/Add';

export default function ValoresRecebidos({ detalhe, idTitulo }: ValoresRecebidosProps) {

    const [openRecb, setOpenRecb] = useState(false)

    //funçoes manipuladoras
    const handleOpenRegistrarRecbDialog = (action: "open" | "close") => {
        if (action === "open") setOpenRecb(true)
        if (action === "close") setOpenRecb(false)
    }
    //

    //valores importantes
    const paddingStyle = { paddingLeft: 0, paddingRight: 0 }

    const valorTitulo = useMemo((): IDataListaTitulosReceber[] => {
        let valorTituloArray: IDataListaTitulosReceber[] = [];

        const valorTitulo: any = {
            id: idTitulo,
            tipo_documento: detalhe.tipo_documento,
            numero_documento: detalhe.numero_documento,
            sequencia_documento: detalhe.sequencia_documento,
            data_vencimento: moment(detalhe.data_vencimento).format("DD/MM/YYYY"),
            valor_original: detalhe.valor_receber,
            tipo_publico: detalhe.publico.tipo_publico,
            codigo_publico: detalhe.publico.codigo_publico,
            nome_publico: detalhe.publico.nome_pessoa,
            data_emissao: moment(detalhe.data_emissao).format("DD/MM/YYYY"),
            comprador: detalhe.comprador,
            numero_nf: detalhe.numero_nf,
            historico: detalhe.historico,
            data_pagamento: moment(detalhe.data_recebimento).format("DD/MM/YYYY"),
            departamento: detalhe.departamento.nome,
            funcao: detalhe.funcao.nome,
            saldo: detalhe.saldo_principal
        };

        valorTituloArray.push(valorTitulo)
        return valorTituloArray;
    }, [detalhe, idTitulo])

    const desabilitarRecb = detalhe.saldo_titulo === 0

    const movRecebimento = useMemo(() => {
        return detalhe.movimentacoes.filter(item => item.tipo_movimento === "6" && item.status_movimento === "A");
    }, [detalhe])

    const totalMovRecb = useMemo(() => {
        return detalhe.movimentacoes
            .filter(item => item.tipo_movimento === "6" && item.status_movimento === "A")
            .reduce((soma, item) => soma + item.valor_movimento, 0);
    }, [detalhe])
    //
    
    const Actions = () => (
        <Stack direction="row" gap={2}>
            <Button
                onClick={() => handleOpenRegistrarRecbDialog("open")}
                variant="outlined"
                size="small"
                startIcon={<AttachMoneyOutlinedIcon />}
            >
                Registrar recebimento
            </Button>
        </Stack>
    )

    return (
        <>
            {
                movRecebimento.length === 0 &&
                <DisplayEmptyListAction
                    label="Nenhum valor recebido foi encontrado para esse título. Deseja incluir?"
                    actionSection={<Actions />}
                />
            }

            {
                movRecebimento.length > 0 &&
                <TableContainer>
                    <Table size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={paddingStyle}><b>Forma</b></TableCell>
                                <TableCell align="right" sx={paddingStyle}><b>Valor</b></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {movRecebimento.map((row, index) => (
                                <TableRow
                                    key={index}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row" sx={paddingStyle}>
                                        {row.forma_recebimento?.nome || "Não informada"}
                                    </TableCell>
                                    <TableCell align="right" sx={paddingStyle}>{formatarValorMonetario(row.valor_movimento)}</TableCell>
                                </TableRow>
                            ))}

                            <TableRow
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row" sx={paddingStyle}><b>Total</b></TableCell>
                                <TableCell align="right" sx={paddingStyle}><b>{formatarValorMonetario(totalMovRecb)}</b></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>

                    <Stack direction="row" justifyContent="flex-end" mt={2}>
                        <Button
                            variant="outlined"
                            size="small"
                            disabled={desabilitarRecb}
                            startIcon={<AddIcon />}
                            onClick={() => handleOpenRegistrarRecbDialog("open")}
                        >
                            Adicionar
                        </Button>
                    </Stack>
                </TableContainer>
            }

            {
                openRecb &&
                <DialogRegistrarRecebimento
                    open={openRecb}
                    handleClose={() => handleOpenRegistrarRecbDialog("close")}
                    valoresTitulos={valorTitulo}
                />
            }
        </>
    )
}

interface ValoresRecebidosProps {
    detalhe: IDataDetalharTitulosReceber;
    idTitulo: string;
}
